export interface Coordinates {
  latitude: number;
  longitude: number;
}

interface Position {
  coords: Coordinates;
}

export class GeolocationService {
  public static getCurrentPosition(signal?: AbortSignal): Promise<Coordinates> {
    return new Promise((resolve, reject) => {
      function abort() {
        cleanup();
        reject(new DOMException('Geolocation request aborted', 'AbortError'));
      }

      function cleanup() {
        signal?.removeEventListener('abort', abort);
      }

      if (signal) {
        signal.addEventListener('abort', abort, { once: true });
        if (signal.aborted) {
          abort();
          return;
        }
      }

      navigator.geolocation.getCurrentPosition(
        (position: Position) => {
          cleanup();
          if (signal?.aborted) return;

          resolve(position.coords);
        },
        (e) => {
          cleanup();
          if (signal?.aborted) return;

          reject(e);
        },
        {
          enableHighAccuracy: true,
          maximumAge: 0,
          timeout: 15000,
        },
      );
    });
  }

  public static getGeolocationPermission(): Promise<PermissionState> {
    return new Promise((resolve, reject) => {
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then((result) => {
            resolve(result.state);
          })
          .catch((error) => reject(error));
      } else {
        reject(new Error('Permissions API not supported'));
      }
    });
  }
}
